<template>
  <Head title="Two-Factor Authentication" />
  <div
    class="from-navy-50 to-navy-100 relative flex min-h-screen items-center justify-center bg-gradient-to-br via-neutral-50 px-4 py-12 sm:px-6 lg:px-8"
  >
    <div
      class="from-navy-500/5 absolute inset-0 bg-gradient-to-br to-green-500/10"
    ></div>

    <div class="relative z-10 w-full max-w-md">
      <div class="rounded-2xl bg-white p-8 shadow-xl">
        <div class="mb-8 text-center">
          <img
            src="/assets/trellis-logo.svg"
            alt="Trellis"
            class="mx-auto mb-4 h-10 w-auto"
          />
          <p class="text-navy-600 text-sm">Two-Factor Authentication</p>
        </div>

        <p class="text-navy-600 mb-6 text-center text-sm">
          Enter the 6-digit code from your authenticator app, or use a backup
          code.
        </p>

        <form
          class="space-y-6"
          @submit.prevent="form.post('/session/verify_mfa')"
        >
          <div>
            <label
              for="code"
              class="text-navy-700 mb-1.5 block text-sm font-medium"
            >
              Authentication Code
            </label>
            <input
              id="code"
              v-model="form.code"
              type="text"
              name="code"
              required
              autocomplete="one-time-code"
              inputmode="numeric"
              maxlength="8"
              class="text-navy-800 w-full rounded-md border border-neutral-300 px-4 py-3 text-center text-xl tracking-widest placeholder-neutral-400 focus:border-green-500 focus:ring-2 focus:ring-green-500/20 focus:outline-none"
              placeholder="000000"
              autofocus
            />
            <div
              v-if="form.errors.code"
              class="mt-2 flex items-center justify-center text-sm text-red-600"
            >
              <i class="pi pi-exclamation-circle mr-1"></i>
              {{ form.errors.code }}
            </div>
          </div>

          <AppButton type="submit" :loading="form.processing" class="w-full">
            Verify
          </AppButton>
        </form>

        <div class="mt-6 text-center">
          <a
            href="/session/new"
            class="text-sm text-green-600 hover:text-green-700"
          >
            ← Back to Sign In
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Head, useForm } from "@inertiajs/vue3"

import AppButton from "../../components/ui/AppButton.vue"

const form = useForm({
  code: "",
})

defineOptions({ layout: false })
</script>
